import React from "react";
import ErrorIMessage from "./ErrorIMessage";
import * as Const from "./../_Const";

const Label = ({ name, errorMessage, label, showLabel = true }) => {
  const isTerminal = Const.isTerminal();
  const textClass = isTerminal ? "text-2xl" : "text-base";
  return (
    <div className="grid grid-cols-2">
      {showLabel && (
        <label htmlFor={name} className={`text-primary dark:text-accent ${textClass} `}>
          {label}
        </label>
      )}
      {!showLabel && <span className="">&nbsp;</span>}
      <div className="justify-self-end">
        <ErrorIMessage errorMessage={errorMessage} />
      </div>
    </div>
  );
};

export default Label;
